var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card-text',[_c('SignatureStructures',{attrs:{"inline":""},on:{"set-structure":function($event){return _vm.$emit('selected-structure', $event)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }